import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import {  ASL_ENDPOINT, aslStateConfig, EGATO_ENDPOINT, egatoStateConfig, PSA_ENDPOINT, PSA_WSZ_ENDPOINT, psaSingleStateConfig, psaStateConfig, psaWszStateConfig, REGIONS_ENDPOINT, regionsStateConfig, SNPA_ENDPOINT, snpaStateConfig, SUBMISSION_ENDPOINT, SUBMISSION_TYPE_ENDPOINT } from './psa.config';
import { PsaService } from './psa.service';
import {  Psa, PsaState } from './psa.model';
import { InitializeStore } from 'src/app/shared/functions/store.functions';
import { FORM_ENDPOINT, formStateConfig } from './form.config';
import { FILES_ENDPOINT, fileStateConfig } from './file.config';
import { submissionStateConfig } from './submission.config';
import { submissionTypeStateConfig } from './submission-type.config';
import { HISTORY_PSA_ENDPOINT, historyPsaStateConfig } from './history-psa.config';
import { TEMPLATE_ENDPOINT, templateStateConfig } from './template.config';
import { NOMINATION_ENDPOINT, nominationStateConfig } from './nomination.config';
import { WATER_SUPPLY_COMPANY_ENDPOINT, WATER_SUPPLY_JOB_ENDPOINT, WATER_SUPPLY_STAFF_ENDPOINT, WATER_SUPPLY_SYSTEM_ENDPOINT, waterSupplyStateConfig, waterSupplySystemStateConfig } from './water-supply.config';
import { NODE_ENDPOINT, nodeStateConfig } from './node.config';
import { CATALOG_SPINNERET_ENDPOINT, catalogSpinneretStateConfig } from './catalog-spinneret.config';
import { CATALOG_SECTION_ENDPOINT, catalogSectionStateConfig } from './catalog-section.config';
import { ARERA_ENDPOINT, areraStateConfig } from './arera.config';
import { IMPROVEMENT_ACTION_ENDPOINT, improvementActionStateConfig } from './stepper-dpsa/azioni-migliorative-step/azioni-migliorative.config';
import { WSZ_ENDPOINT, wszStateConfig } from './stepper-dpsa/wsz-step/wsz.config';
import { DANGEROUS_EVENT_ENDPOINT, dangerousEventStateConfig } from '../settings/components/dangerous-events/dangerous-events.config';
import { DANGEROUS_ELEMENT_ENDPOINT, dangerousElementStateConfig } from '../settings/components/dangerous-elements/dangerous-elements.config';
import { CONTROL_MEASURE_EQUIPMENT_LINKS_ENDPOINT, CONTROL_MEASURE_OPERATIONAL_MONITORING_LINKS_ENDPOINT, controlMeasureEquipmentLinksStateConfig, controlMeasureOperationalMonitoringLinksStateConfig, DANGEROUS_ELEMENT_CONTROL_MEASURE_LINKS_ENDPOINT, DANGEROUS_EVENT_DANGEROUS_ELEMENT_LINKS_ENDPOINT, dangerousElementControlMeasureLinksStateConfig, dangerousEventDangerousElementLinksStateConfig, REGISTRIES_ENDPOINT, registriesStateConfig } from '../settings/components/settings-associations/settings-association.config';
import { CONTROL_MEASURE_ENDPOINT, controlMeasureStateConfig } from '../settings/components/control-measure/control-measure.config';
import { EQUIPMENT_ENDPOINT, equipmentStateConfig } from '../settings/components/settings-equipment/settings-equipment.config';



@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<Psa>(PSA_ENDPOINT, psaStateConfig),
    ...provideQueryService<any>(FORM_ENDPOINT, formStateConfig),
    ...provideQueryService<any>(FILES_ENDPOINT, fileStateConfig),
    ...provideQueryService<any>(SUBMISSION_ENDPOINT, submissionStateConfig),
    ...provideQueryService<any>(SUBMISSION_TYPE_ENDPOINT, submissionTypeStateConfig),
    ...provideQueryService<any>(HISTORY_PSA_ENDPOINT, historyPsaStateConfig),
    ...provideQueryService<any>(TEMPLATE_ENDPOINT, templateStateConfig),
    ...provideQueryService<any>(NOMINATION_ENDPOINT, nominationStateConfig),
    ...provideQueryService<any>(WATER_SUPPLY_STAFF_ENDPOINT, waterSupplyStateConfig),
    ...provideQueryService<any>(WATER_SUPPLY_JOB_ENDPOINT, waterSupplyStateConfig),
    ...provideQueryService<any>(WATER_SUPPLY_COMPANY_ENDPOINT, waterSupplyStateConfig),
    ...provideQueryService<any>(NODE_ENDPOINT, nodeStateConfig),
    ...provideQueryService<any>(CATALOG_SPINNERET_ENDPOINT, catalogSpinneretStateConfig),
    ...provideQueryService<any>(CATALOG_SECTION_ENDPOINT, catalogSectionStateConfig),
    ...provideQueryService<any>(ARERA_ENDPOINT, areraStateConfig),
    ...provideQueryService<any>(REGIONS_ENDPOINT, regionsStateConfig),
    ...provideQueryService<any>(EGATO_ENDPOINT, egatoStateConfig),
    ...provideQueryService<any>(ASL_ENDPOINT, aslStateConfig),
    ...provideQueryService<any>(SNPA_ENDPOINT, snpaStateConfig),
    ...provideQueryService<any>(WATER_SUPPLY_SYSTEM_ENDPOINT, waterSupplySystemStateConfig),
    ...provideQueryService<any>(IMPROVEMENT_ACTION_ENDPOINT, improvementActionStateConfig),
    ...provideQueryService<any>(WSZ_ENDPOINT, wszStateConfig),
    ...provideQueryService<any>(PSA_WSZ_ENDPOINT, psaWszStateConfig),
    ...provideQueryService<any>(DANGEROUS_EVENT_ENDPOINT, dangerousEventStateConfig),
    ...provideQueryService<any>(DANGEROUS_ELEMENT_ENDPOINT, dangerousElementStateConfig),
    ...provideQueryService<any>(DANGEROUS_EVENT_DANGEROUS_ELEMENT_LINKS_ENDPOINT, dangerousEventDangerousElementLinksStateConfig),
    ...provideQueryService<any>(CONTROL_MEASURE_ENDPOINT, controlMeasureStateConfig),
    ...provideQueryService<any>(DANGEROUS_ELEMENT_CONTROL_MEASURE_LINKS_ENDPOINT, dangerousElementControlMeasureLinksStateConfig),
    ...provideQueryService<any>(CONTROL_MEASURE_OPERATIONAL_MONITORING_LINKS_ENDPOINT, controlMeasureOperationalMonitoringLinksStateConfig),
    ...provideQueryService<any>(REGISTRIES_ENDPOINT, registriesStateConfig),
    ...provideQueryService<any>(EQUIPMENT_ENDPOINT, equipmentStateConfig),
    ...provideQueryService<any>(CONTROL_MEASURE_EQUIPMENT_LINKS_ENDPOINT, controlMeasureEquipmentLinksStateConfig),
    PsaService,
    //da togliere
    ...InitializeStore<PsaState>('psa-store', psaSingleStateConfig),
  ],
  imports: [
    CommonModule
  ],
})
export class PsaModule { }
